import { BrazeUser } from '../../../@types/braze'
import { ConsentResult } from './mapConsent'

export const setConsentAttributes = (brazeUser: BrazeUser, consent: ConsentResult): void => {
  if (consent.adUserData !== null) {
    brazeUser.setCustomUserAttribute?.('$google_ad_user_data', consent.adUserData)
  }

  if (consent.adPersonalization !== null) {
    brazeUser.setCustomUserAttribute?.('$google_ad_personalization', consent.adPersonalization)
  }
}
